export function validateRatio(ratio: string): boolean {
    {
        if (ratio === 'auto') {
            return true;
        }

        // Match `ratio-3-4` or `3-4` patterns strictly
        const ratioPattern = /^(ratio-)?\d+-\d+$/;

        // Match fractions like `3/4` strictly
        const fractionPattern = /^\d+\/\d+$/;

        // Match valid numeric strings (e.g., "0.75", "55") strictly
        const numericPattern = /^\d+(\.\d+)?$/;

        // Check if it matches any of the valid patterns
        if (ratioPattern.test(ratio) || fractionPattern.test(ratio) || numericPattern.test(ratio)) {
            return true;
        }

        // Invalid if none of the patterns match
        return false;
    }
}
